"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _coreBaseProps = require("@legacy-vfuk/core-base-props");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Star = function Star(_ref) {
  var type = _ref.type,
    inverse = _ref.inverse,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var gradientId = (0, _uuid.v4)();
  var _ref2 = (0, _styledComponents.useTheme)(),
    color = _ref2.color,
    inverseColor = _ref2.inverseColor;
  var starFill = function starFill() {
    if (type === 'full') {
      return inverse ? inverseColor.secondary1["default"] : color.secondary1["default"];
    }
    return 'none';
  };
  return /*#__PURE__*/_react["default"].createElement("svg", {
    "aria-hidden": "true",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: starFill(),
    xmlns: "http://www.w3.org/2000/svg",
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, type === 'halfFull' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.74829 6.67499L6.07579 5.95999L7.93912 1.98999L9.95662 5.88416L14.3083 6.42999L11.2283 9.55166L12.0533 13.8592L8.13246 11.8942L4.29162 14.01L4.94829 9.67416L1.74829 6.67499Z",
    fill: "url(#".concat(gradientId, ")"),
    stroke: inverse ? inverseColor.secondary1["default"] : color.secondary1["default"],
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: gradientId,
    x1: "1.33329",
    y1: "2",
    x2: "15",
    y2: "2",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.463542",
    stopColor: inverse ? inverseColor.secondary1["default"] : color.secondary1["default"]
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0.463642",
    stopColor: "white",
    stopOpacity: "0"
  })))) : /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.74829 6.67499L6.07579 5.95999L7.93912 1.98999L9.95662 5.88416L14.3083 6.42999L11.2283 9.55166L12.0533 13.8592L8.13246 11.8942L4.29162 14.01L4.94829 9.67416L1.74829 6.67499Z",
    fill: "",
    stroke: inverse ? inverseColor.secondary1["default"] : color.secondary1["default"],
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
Star.displayName = "Star";
var _default = Star;
exports["default"] = _default;
//# sourceMappingURL=Star.js.map